export const environment = {
  name: 'test',
  production: true,
  apiUrl: "https://api.chqtest.net",
  appUriWeb: 'https://app.chqtest.net',
  ocppUrl: 'ws://ocpp.chqtest.net/ocpp16/',
  cognitoClientId: '2g2v4idl4hpvpvrrdee2g5b1rm',
  cognitoUrl: 'https://auth.chqtest.net',
};
